export default "__VITE_ASSET__ivsPT94L__"